import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../components/common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import { RMAXLogger } from "../../../services/LoggerService/RMAXLogger";
import styles from "./styles";

const toggleAutoZoom = ({
  isEnabled,
  toggleRouteAnimation,
  eventHub,
}) => {
  eventHub.emit("routeAnimation", !isEnabled);
  const eventSpecificData = {
    autoZoomEnabled: !isEnabled,
  };
  RMAXLogger.info("AutoZoom", eventSpecificData);
  toggleRouteAnimation && toggleRouteAnimation(!isEnabled);
};
const MapAutoZoom = ({ classes, ...props }) => {
  const label = `${props.isEnabled ? "Disable" : "Enable"} Auto Zoom`;
  return (
    <Tooltip title={props.title}>
      <div
        className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""} `}
      >
        <div className={classes.toggleText}>{label}</div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={() => toggleAutoZoom(props)}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(MapAutoZoom);
